export const setLastVisitedProductTitle = (): void => {
  const mainProductElem: HTMLElement = document.querySelector('[data-main-product-title]');
  const productTitle: string = mainProductElem.dataset.mainProductTitle;
  localStorage.setItem('bbLastVisitedProductTitle', productTitle);
}